exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "input[type=number] {\n  -moz-appearance: textfield; }\n\ninput:invalid {\n  -webkit-box-shadow: none;\n          box-shadow: none; }\n\n/*\n * It's also possible to overwrite the styles for certain validation rules.\n */\ninput:required {\n  -webkit-box-shadow: none;\n          box-shadow: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/TextField/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/TextField/index.css
// module chunks = 504